import React from 'react';


const Lat_Epi_Intro = () => {
    return (
        <div>
            <div className='title-margins'>
                <h2>Introduction to Tennis Elbow (Lateral Epicondylopathy)</h2>
                
            </div>
            <div className='title-break'>
                <span>High Risk Sports</span>
            </div>
            <div className='high-risk-list my-3 py-1'>
                <div className="result-sport-figure">
                    <img src='/assets/imgs/results/athletes/quarterback.png' alt="" />
                    <span>Football</span>
                </div>
                <div className="result-sport-figure mb-2">
                    <img src='/assets/imgs/results/athletes/baseball-pitcher.png' alt=""/>
                    <span>Baseball</span>
                </div>
                <div className="result-sport-figure">
                    <img src='/assets/imgs/results/athletes/tennis.png' alt=""/>
                    <span>Tennis</span>
                </div>
            </div>
            <div className='title-break'>
                <span>Overview</span>
            </div>
            
            <div className="card">
                <img src="/assets/imgs/results/content/TennisCut.jpg" alt="" height={200} className="overview-img" />
                <p>Lateral epicondylopathy, commonly known as tennis elbow, is an overload injury of the common extensor tendon that originates at the lateral humeral epicondyle (<a target="_blank" rel="noopener noreferrer" href="https://pubmed.ncbi.nlm.nih.gov/9802175/">Field and Savoie, 1998</a>, <a target="_blank" rel="noopener noreferrer" href="https://pubmed.ncbi.nlm.nih.gov/37342924/">Wolf, 2023</a>). The tendon most often involved, called the extensor carpi radialis brevis, helps stabilize the wrist when you grip or lift objects. </p>
                <p>There is an insidious onset of lateral elbow pain, with tenderness at the lateral epicondyle and pain with resisted wrist extension. Lateral epicondylopathy is caused by a complex degenerative process termed angiofibroblastic tendinosis, characterized by fibroblast infiltration, vascular hyperplasia, disorganized collagen and elevated inflammatory cytokines (including interleukin-1α and tumor necrosis factor).</p>
                <p className="mb-0">When the tendon is used over and over again, tiny microscopic tears form in the collagen fibers. In a healthy tendon those tears would heal, but in tennis elbow the healing process breaks down. The tissue becomes disorganized and weaker, new fragile blood vessels grow in, and pain-sensing nerve fibers move into the area. Instead of smooth, strong tendon, there is a patch of tissue that is stiff, poorly structured, and sensitive. This is why the pain feels sharp or burning when you grip something, shake hands, or lift with your palm facing down.</p>
            </div>
            <div className='title-break'>
                <span>Frequency</span>
            </div>
            <div className="card">
                <p className="mb-0">Tennis elbow is a relatively common condition in adults, affecting about 1% to 3% of adults in the general population. In people who play racket sports, especially tennis, the prevalence is much higher because of repetitive wrist extension and gripping forces. Around 40% to 50% of regular tennis players develop tennis elbow at some point.</p>
            </div>
        </div>
    );
};

export default Lat_Epi_Intro;